import { Link } from 'react-router-dom';



export default function FrontMenuSection(props)
{
	const items = props.items?.map((item) => {
		return (
			<li key={ item.label } className='f-header__nav--categories__active--list'>
				<Link to={ item.path }
					className='f-header__nav--categories__active--link'>
					{ item.label }
				</Link>
			</li>
		)
	});

	return (
		<ul>
			{ items }
		</ul>
	)
}